(function(f){if(typeof exports==="object"&&typeof module!=="undefined"){module.exports=f()}else if(typeof define==="function"&&define.amd){define([],f)}else{var g;if(typeof window!=="undefined"){g=window}else if(typeof global!=="undefined"){g=global}else if(typeof self!=="undefined"){g=self}else{g=this}g.standalone = f()}})(function(){var define,module,exports;return (function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Context = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var Context =
/*#__PURE__*/
function () {
  function Context(current, parent, key, alias) {
    _classCallCheck(this, Context);

    this.key = key;
    this.alias = alias || key;
    this.current = current;
    this.parent = parent;
  }

  _createClass(Context, null, [{
    key: "create",
    value: function create(current, parent, key, alias) {
      return new Context(current, parent, key, alias);
    }
  }, {
    key: "from",
    value: function from(obj) {
      return this.create(obj.current, obj.parent, obj.key, obj.alias);
    }
  }]);

  return Context;
}();

exports.Context = Context;

},{}],2:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _utils = require("../utils");

/** @module ego */

/** @namespace module:ego~ERROR_KEYS */
var ERROR_KEYS = (0, _utils.freeze)({
  /**
   * @memberof module:ego~ERROR_KEYS
   * 
   * @example
   * ANY: {
   *  UNKNOWN: 'any.unknown',
   *  REQUIRED: 'any.required',
   *  ALLOW: 'any.allow',
   * }
   */
  ANY: {
    UNKNOWN: 'any.unknown',
    REQUIRED: 'any.required',
    ALLOW: 'any.allow'
  },

  /**
   * @memberof module:ego~ERROR_KEYS
   * 
   * @example
   * 
   * NUMBER: {
   *  TYPE: 'number.type',
   *  GE: 'number.ge',
   *  GT: 'number.gt',
   *  LE: 'number.le',
   *  LT: 'number.lt',
   *  RANGE: 'number.range',
   * }
   * 
   */
  NUMBER: {
    TYPE: 'number.type',
    GE: 'number.ge',
    GT: 'number.gt',
    LE: 'number.le',
    LT: 'number.lt',
    RANGE: 'number.range'
  },

  /**
   * @memberof module:ego~ERROR_KEYS
   * 
   * @example
   * 
   * STRING: {
   *  EMPTY: 'string.empty',
   *  TYPE: 'string.type',
   *  EMAIL: 'string.email',
   *  MATCH: 'string.match',
   *  MIN_LENGTH: 'string.min.length',
   *  MAX_LENGTH: 'string.max.length',
   *  LENGTH: 'string.exact.length',
   *  DIGITS: 'string.digits',
   *  ALPHANUM: 'string.alphanum',
   *  ISO_DATE: 'string.iso.date',
   * }
   * 
   */
  STRING: {
    EMPTY: 'string.empty',
    TYPE: 'string.type',
    EMAIL: 'string.email',
    MATCH: 'string.match',
    MIN_LENGTH: 'string.min.length',
    MAX_LENGTH: 'string.max.length',
    LENGTH: 'string.exact.length',
    DIGITS: 'string.digits',
    ALPHANUM: 'string.alphanum',
    ISO_DATE: 'string.iso.date'
  },

  /**
   * @memberof module:ego~ERROR_KEYS
   * 
   * @example
   * 
   * BOOLEAN: {
   *  TYPE: 'boolean.type',
   *  TRUTHY: 'boolean.truthy',
   *  FALSY: 'boolean.falsy',
   * }
   * 
   */
  BOOLEAN: {
    TYPE: 'boolean.type',
    TRUTHY: 'boolean.truthy',
    FALSY: 'boolean.falsy'
  },

  /**
   * @memberof module:ego~ERROR_KEYS
   * 
   * @example
   * 
   * SHAPE: {
   *  TYPE: 'shape.type',
   *  ALLOWED_KEYS: 'shape.allowed.keys',
   *  FORBIDDEN_KEYS: 'shape.forbidden.keys',
   *  EXPECTED_KEYS: 'shape.expected.keys',
   * }
   * 
   */
  SHAPE: {
    TYPE: 'shape.type',
    ALLOWED_KEYS: 'shape.allowed.keys',
    FORBIDDEN_KEYS: 'shape.forbidden.keys',
    EXPECTED_KEYS: 'shape.expected.keys'
  },

  /**
   * @memberof module:ego~ERROR_KEYS
   * 
   * @example
   * 
   * ARRAY: {
   *  TYPE: 'array.type',
   *  MIN_LENGTH: 'array.min.length',
   *  MAX_LENGTH: 'array.max.length',
   *  IN_RANGE: 'array.range',
   *  LENGTH: 'array.exact.length',
   *  EVERY: 'array.every',
   *  SOME: 'array.some',
   * }
   * 
   */
  ARRAY: {
    TYPE: 'array.type',
    MIN_LENGTH: 'array.min.length',
    MAX_LENGTH: 'array.max.length',
    IN_RANGE: 'array.range',
    LENGTH: 'array.exact.length',
    EVERY: 'array.every',
    SOME: 'array.some'
  }
});
var _default = ERROR_KEYS;
exports["default"] = _default;

},{"../utils":7}],3:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _keys = _interopRequireDefault(require("./keys"));

var _like = _interopRequireDefault(require("../like.lodash"));

var _Object$freeze;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var ANY = _keys["default"].ANY,
    NUMBER = _keys["default"].NUMBER,
    STRING = _keys["default"].STRING,
    BOOLEAN = _keys["default"].BOOLEAN,
    SHAPE = _keys["default"].SHAPE,
    ARRAY = _keys["default"].ARRAY;
var MESSAGES = Object.freeze((_Object$freeze = {}, _defineProperty(_Object$freeze, ANY.UNKNOWN, function (_ref) {
  var label = _ref.label;
  return "".concat(label, " contains errors");
}), _defineProperty(_Object$freeze, ANY.REQUIRED, function (_ref2) {
  var label = _ref2.label;
  return "".concat(label, " is required");
}), _defineProperty(_Object$freeze, ANY.ALLOW, function (_ref3) {
  var label = _ref3.label,
      args = _ref3.args;
  return "".concat(label, " should be one of allowed values: ").concat(args.join(', '));
}), _defineProperty(_Object$freeze, NUMBER.TYPE, function (_ref4) {
  var label = _ref4.label;
  return "".concat(label, " should be a number");
}), _defineProperty(_Object$freeze, NUMBER.GT, function (_ref5) {
  var label = _ref5.label,
      args = _ref5.args;
  return "".concat(label, " should be greater than ").concat(args);
}), _defineProperty(_Object$freeze, NUMBER.LT, function (_ref6) {
  var label = _ref6.label,
      args = _ref6.args;
  return "".concat(label, " should be less than ").concat(args);
}), _defineProperty(_Object$freeze, NUMBER.GE, function (_ref7) {
  var label = _ref7.label,
      args = _ref7.args;
  return "".concat(label, " should be greater than or equal to ").concat(args);
}), _defineProperty(_Object$freeze, NUMBER.LE, function (_ref8) {
  var label = _ref8.label,
      args = _ref8.args;
  return "".concat(label, " should be less than or equal to ").concat(args);
}), _defineProperty(_Object$freeze, NUMBER.RANGE, function (_ref9) {
  var label = _ref9.label,
      _ref9$args = _slicedToArray(_ref9.args, 2),
      min = _ref9$args[0],
      max = _ref9$args[1];

  return "".concat(label, " should be less than ").concat(max, " and greater than or equal to ").concat(min);
}), _defineProperty(_Object$freeze, STRING.EMPTY, function (_ref10) {
  var label = _ref10.label;
  return "".concat(label, " should not be blank");
}), _defineProperty(_Object$freeze, STRING.TYPE, function (_ref11) {
  var label = _ref11.label;
  return "".concat(label, " should be a string");
}), _defineProperty(_Object$freeze, STRING.MATCH, function (_ref12) {
  var label = _ref12.label,
      args = _ref12.args;
  return "".concat(label, " should match the pattern ").concat(args);
}), _defineProperty(_Object$freeze, STRING.MIN_LENGTH, function (_ref13) {
  var label = _ref13.label,
      args = _ref13.args;
  return "".concat(label, " should have at least ").concat(args, " characters");
}), _defineProperty(_Object$freeze, STRING.MAX_LENGTH, function (_ref14) {
  var label = _ref14.label,
      args = _ref14.args;
  return "".concat(label, " should have at most ").concat(args, " characters");
}), _defineProperty(_Object$freeze, STRING.LENGTH, function (_ref15) {
  var label = _ref15.label,
      args = _ref15.args;
  return "".concat(label, " should have only ").concat(args, " characters");
}), _defineProperty(_Object$freeze, STRING.EMAIL, function (_ref16) {
  var label = _ref16.label;
  return "".concat(label, " should be a valid email address");
}), _defineProperty(_Object$freeze, STRING.DIGITS, function (_ref17) {
  var label = _ref17.label;
  return "".concat(label, " should contain only digits");
}), _defineProperty(_Object$freeze, STRING.ALPHANUM, function (_ref18) {
  var label = _ref18.label;
  return "".concat(label, " should contain only alphanumeric characters");
}), _defineProperty(_Object$freeze, STRING.ISO_DATE, function (_ref19) {
  var label = _ref19.label;
  return "".concat(label, " should be an ISO Date");
}), _defineProperty(_Object$freeze, BOOLEAN.TYPE, function (_ref20) {
  var label = _ref20.label;
  return "".concat(label, " should be a boolean");
}), _defineProperty(_Object$freeze, BOOLEAN.TRUTHY, function (_ref21) {
  var label = _ref21.label;
  return "".concat(label, " should be true");
}), _defineProperty(_Object$freeze, BOOLEAN.FALSY, function (_ref22) {
  var label = _ref22.label;
  return "".concat(label, " should be false");
}), _defineProperty(_Object$freeze, SHAPE.TYPE, function (_ref23) {
  var label = _ref23.label;
  return "".concat(label, " should be an object");
}), _defineProperty(_Object$freeze, SHAPE.ALLOWED_KEYS, function (_ref24) {
  var label = _ref24.label,
      value = _ref24.value,
      args = _ref24.args;
  var keys = _like["default"].keys(value).join(', ') || 'no keys';
  return "".concat(label, " contains: ").concat(keys, ", but should contain only keys: ").concat(args.join(', '));
}), _defineProperty(_Object$freeze, SHAPE.EXPECTED_KEYS, function (_ref25) {
  var label = _ref25.label,
      value = _ref25.value,
      args = _ref25.args;
  var keys = _like["default"].keys(value).join(', ') || 'no keys';
  return "".concat(label, " contains: ").concat(keys, ", but should have keys: ").concat(args.join(', '));
}), _defineProperty(_Object$freeze, SHAPE.FORBIDDEN_KEYS, function (_ref26) {
  var label = _ref26.label,
      args = _ref26.args;
  return "".concat(label, " contains forbidden keys: ").concat(args.join(', '));
}), _defineProperty(_Object$freeze, ARRAY.TYPE, function (_ref27) {
  var label = _ref27.label;
  return "".concat(label, " should be an array");
}), _defineProperty(_Object$freeze, ARRAY.LENGTH, function (_ref28) {
  var label = _ref28.label,
      args = _ref28.args;
  return "".concat(label, " should have ").concat(args, " items");
}), _defineProperty(_Object$freeze, ARRAY.MIN_LENGTH, function (_ref29) {
  var label = _ref29.label,
      args = _ref29.args;
  return "".concat(label, " should have at least ").concat(args, " items");
}), _defineProperty(_Object$freeze, ARRAY.MAX_LENGTH, function (_ref30) {
  var label = _ref30.label,
      args = _ref30.args;
  return "".concat(label, " should have at most ").concat(args, " items");
}), _defineProperty(_Object$freeze, ARRAY.IN_RANGE, function (_ref31) {
  var label = _ref31.label,
      _ref31$args = _slicedToArray(_ref31.args, 2),
      min = _ref31$args[0],
      max = _ref31$args[1];

  return "".concat(label, " should have length between ").concat(min, " and ").concat(max);
}), _defineProperty(_Object$freeze, ARRAY.SOME, function (_ref32) {
  var label = _ref32.label;
  return "".concat(label, " should have at least one item that follows the rule");
}), _defineProperty(_Object$freeze, ARRAY.EVERY, function (_ref33) {
  var label = _ref33.label;
  return "".concat(label, " items should follow the rule");
}), _Object$freeze));
var _default = MESSAGES;
exports["default"] = _default;

},{"../like.lodash":5,"./keys":2}],4:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "spec", {
  enumerable: true,
  get: function get() {
    return _specification["default"];
  }
});
Object.defineProperty(exports, "validators", {
  enumerable: true,
  get: function get() {
    return _validators["default"];
  }
});
Object.defineProperty(exports, "toValidator", {
  enumerable: true,
  get: function get() {
    return _utils.toValidator;
  }
});
Object.defineProperty(exports, "toValidatorWithArgs", {
  enumerable: true,
  get: function get() {
    return _utils.toValidatorWithArgs;
  }
});
Object.defineProperty(exports, "ERROR_KEYS", {
  enumerable: true,
  get: function get() {
    return _keys["default"];
  }
});
Object.defineProperty(exports, "ERROR_MESSAGES", {
  enumerable: true,
  get: function get() {
    return _messages["default"];
  }
});
exports.createValidateFunction = exports.validateAllWithOpts = exports.validateAll = exports.validateWithOpts = exports.validate = exports.isInvalid = exports.isValid = void 0;

var _specification = _interopRequireDefault(require("./specification"));

var _validate = _interopRequireDefault(require("./validate"));

var _validators = _interopRequireDefault(require("./validators"));

var _utils = require("./utils");

var _keys = _interopRequireDefault(require("./defaults/keys"));

var _messages = _interopRequireDefault(require("./defaults/messages"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var isValid = _validate["default"].isValid,
    isInvalid = _validate["default"].isInvalid,
    validate = _validate["default"].validate,
    validateWithOpts = _validate["default"].validateWithOpts,
    validateAll = _validate["default"].validateAll,
    validateAllWithOpts = _validate["default"].validateAllWithOpts,
    createValidateFunction = _validate["default"].createValidateFunction;
exports.createValidateFunction = createValidateFunction;
exports.validateAllWithOpts = validateAllWithOpts;
exports.validateAll = validateAll;
exports.validateWithOpts = validateWithOpts;
exports.validate = validate;
exports.isInvalid = isInvalid;
exports.isValid = isValid;

},{"./defaults/keys":2,"./defaults/messages":3,"./specification":6,"./utils":7,"./validate":8,"./validators":12}],5:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.overArgs = exports.getOr = exports.get = exports.cond = exports.includes = exports.stubTrue = exports.entries = exports.keys = exports.assign = exports.reverse = exports.has = exports.some = exports.every = exports.identity = exports.isEmpty = exports.isArray = exports.isObject = exports.isFunction = exports.isString = exports.isBoolean = exports.isDate = exports.isNumber = exports.isType = exports.curry = exports.flow = exports.getInternalCtor = void 0;

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

var baseToString = Object.prototype.toString; // slice(8, -1) goes from skip '[object' and takes only constructor name bypassing closing square bracket

var getInternalCtor = function getInternalCtor(value) {
  return baseToString.call(value).slice(8, -1);
};

exports.getInternalCtor = getInternalCtor;

var flow = function flow() {
  for (var _len = arguments.length, fncs = new Array(_len), _key = 0; _key < _len; _key++) {
    fncs[_key] = arguments[_key];
  }

  return function (value) {
    return fncs.reduce(function (result, fn) {
      return fn(result);
    }, value);
  };
};

exports.flow = flow;

var curry = function curry(fn) {
  var currierX = function currierX() {
    for (var _len2 = arguments.length, xargs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      xargs[_key2] = arguments[_key2];
    }

    var currierY = function currierY() {
      for (var _len3 = arguments.length, yargs = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        yargs[_key3] = arguments[_key3];
      }

      var fullArgs = [].concat(xargs, yargs);

      if (fn.length <= fullArgs.length) {
        return fn.apply(void 0, _toConsumableArray(fullArgs));
      }

      return currierX.apply(void 0, _toConsumableArray(fullArgs));
    };

    if (fn.length <= xargs.length) {
      return fn.apply(void 0, xargs);
    }

    return currierY;
  };

  return currierX;
};

exports.curry = curry;
var isType = curry(function (type, value) {
  return getInternalCtor(value) === type;
});
exports.isType = isType;
var isNumber = isType('Number');
exports.isNumber = isNumber;
var isDate = isType('Date');
exports.isDate = isDate;
var isBoolean = isType('Boolean');
exports.isBoolean = isBoolean;
var isString = isType('String');
exports.isString = isString;
var isFunction = isType('Function');
exports.isFunction = isFunction;

var isObject = function isObject(value) {
  return _typeof(value) === 'object' && value !== null;
};

exports.isObject = isObject;

var isArray = function isArray(value) {
  return Array.isArray(value);
};

exports.isArray = isArray;

var isEmpty = function isEmpty(value) {
  if (value == null) {
    return true;
  }

  return Object.keys(value).length === 0;
};

exports.isEmpty = isEmpty;

var identity = function identity(v) {
  return v;
};

exports.identity = identity;
var every = curry(function (predicate, value) {
  if (isArray(value)) {
    return Array.prototype.every.call(value, predicate);
  }

  return true;
});
exports.every = every;
var some = curry(function (predicate, value) {
  if (isArray(value)) {
    return Array.prototype.some.call(value, predicate);
  }

  return true;
});
exports.some = some;

var has = function has(prop, value) {
  return Object.prototype.hasOwnProperty.call(value, prop);
};

exports.has = has;

var reverse = function reverse(value) {
  return Array.prototype.reverse.call(value);
};

exports.reverse = reverse;

var assign = function assign(a, b) {
  return Object.assign(a, b);
};

exports.assign = assign;

var keys = function keys(value) {
  return Object.keys(value);
};

exports.keys = keys;

var entries = function entries(value) {
  return Object.entries(value);
};

exports.entries = entries;

var stubTrue = function stubTrue() {
  return true;
};

exports.stubTrue = stubTrue;

var includes = function includes(value, args) {
  return Array.prototype.includes.call(args, value);
};

exports.includes = includes;

var cond = function cond(rules) {
  return function (value) {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = rules[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var _step$value = _slicedToArray(_step.value, 2),
            predicate = _step$value[0],
            action = _step$value[1];

        if (predicate(value)) {
          return action(value);
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
          _iterator["return"]();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  };
};

exports.cond = cond;
var get = curry(function (path, value) {
  if (value == null) {
    return undefined;
  }

  if (has(path, value)) {
    return value[path];
  }

  var stage = value;
  var pathParts = path.split('.');
  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = pathParts[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var part = _step2.value;

      if (isObject(stage)) {
        stage = stage[part];
        continue;
      }

      return undefined;
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2["return"] != null) {
        _iterator2["return"]();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }

  return stage;
});
exports.get = get;

var getOr = function getOr(defValue, path) {
  return function (value) {
    var result = get(path, value);
    return result === undefined ? defValue : result;
  };
};

exports.getOr = getOr;

var overArgs = function overArgs(transform, fnsFlow) {
  return function () {
    var results = [];

    for (var i = 0, l = arguments.length; i < l; i += 1) {
      var fn = fnsFlow[i] || identity;
      results.push(fn(i < 0 || arguments.length <= i ? undefined : arguments[i]));
    }

    return transform.apply(void 0, results);
  };
};

exports.overArgs = overArgs;
var _default = {
  flow: flow,
  curry: curry,
  assign: assign,
  cond: cond,
  entries: entries,
  every: every,
  some: some,
  get: get,
  getOr: getOr,
  identity: identity,
  includes: includes,
  keys: keys,
  overArgs: overArgs,
  reverse: reverse,
  stubTrue: stubTrue,
  isEmpty: isEmpty,
  isArray: isArray,
  isNumber: isNumber,
  isBoolean: isBoolean,
  isObject: isObject,
  isString: isString,
  isFunction: isFunction
};
exports["default"] = _default;

},{}],6:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _like = _interopRequireDefault(require("./like.lodash"));

var _context = require("./context");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var SPEC_FN_SYMBOL = Symbol('spec-fn-symbol');

var LazySpec =
/*#__PURE__*/
function () {
  function LazySpec(lazy) {
    _classCallCheck(this, LazySpec);

    this.lazy = lazy;
  }

  _createClass(LazySpec, null, [{
    key: "isLazy",
    value: function isLazy(value) {
      return value instanceof LazySpec;
    }
  }]);

  return LazySpec;
}();

var nullOrCollection = _like["default"].cond([[_like["default"].isEmpty, function () {
  return null;
}], [_like["default"].stubTrue, _like["default"].identity]]);

var isSpec = function isSpec(spec) {
  return Boolean(spec[SPEC_FN_SYMBOL]);
};

var asSpec = function asSpec(specFn) {
  specFn[SPEC_FN_SYMBOL] = true;
  return Object.freeze(specFn);
};

var _default = {
  /**
   * Usage of function makes sense only if u have spec flow outside of object context
   * or collection context and want to rename output label for validation message
   * @function designate
   * @memberof module:ego~spec
   * 
   * @arg {string} key - key to use instead of 'value' for label to output validation message
   * @arg {function} spec - Accpets spec function
   * 
   * @returns {function} - Spec function which could be used as argument for lib functions
   * 
   * @example
   * 
   * import { spec } from 'egoist-js'
   * 
   * const asUserSpec = spec.designate('user')
   * 
   * const userModelSpec = spec.compose(
   *   asUserSpec(spec.flow(required)),
   *   spec.of({
   *     username: spec.flow(isNotEmpty, required),
   *     friends: spec.of([spec.lazy(() => userModelSpec)]),
   *   })
   * )
   * 
   * const result = validate(null, { untilFail: true })
   * // [{ message: 'user is required', value: null, args: undefined, path: [] }]
   * 
   */
  designate: _like["default"].curry(function (alias, spec) {
    return asSpec(function (value) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var refinedOpts = _objectSpread({}, options, {
        context: _context.Context.from(_objectSpread({}, options.context, {
          alias: alias
        }))
      });

      return spec(value, refinedOpts);
    });
  }),

  /**
   * Function is used to create a lazy evaluate specification item
   * @function lazy
   * @memberof module:ego~spec
   * 
   * @arg {function} getSpecLazy - Expected spec function to be passed 
   * 
   * @returns {LazySpec} - Object which could be used as argument for #compose, #of functions
   * 
   * @example
   *    
   * import { spec } from 'egoist-js'
   * 
   * const userModelSpec = spec.of({
   *  username: spec.flow(string.isNotEmpty, any.required),
   *  bestFriend: spec.lazy(() => userModelSpec), // returns lazy evaluated spec function
   * })
   * 
   */
  lazy: function lazy(getSpecLazy) {
    if (!_like["default"].isFunction(getSpecLazy)) {
      throw new Error('lazy expects function as an argument');
    }

    return new LazySpec(getSpecLazy);
  },

  /**
   * Function is used to create validation flow
   * @function flow
   * @memberof module:ego~spec
   * 
   * @arg {function[]} ...validators - Accepts validation functions as list of arguments
   * 
   * @returns {function} - Spec function which could be used as argument
   * 
   * @example
   * 
   * import { spec } from 'egoist-js'
   * 
   * const usernameSpec = spec.flow(
   *  string.isString,
   *  string.match(/^[A-Z][a-z]+\s[A-Z][a-z]+$/)
   *  string.isNotMatch,
   *  any.required
   * )
   * 
   */
  flow: function flow() {
    for (var _len = arguments.length, validators = new Array(_len), _key = 0; _key < _len; _key++) {
      validators[_key] = arguments[_key];
    }

    return asSpec(function (value, options) {
      var results = [];

      var _fp$assign = _like["default"].assign({
        context: null,
        untilFail: false
      }, options),
          context = _fp$assign.context,
          untilFail = _fp$assign.untilFail;

      for (var i = 0, l = validators.length; i < l; i += 1) {
        var validator = validators[i];
        var result = validator(value, {
          context: context
        });

        if (_like["default"].isArray(result)) {
          results.push({
            result: result,
            value: value,
            context: context
          });
        }

        if (untilFail && results.length > 0) {
          return results;
        }
      }

      return nullOrCollection(results);
    });
  },

  /**
   * Function is used to create a composition between specification functions
   * @function compose
   * @memberof module:ego~spec
   * 
   * @arg {function[]} ...specs - Accpets spec functions as list of arguments
   * 
   * @returns {function} - Spec function which could be used as argument
   * 
   * @example
   * 
   * import { spec } from 'egoist-js'
   * 
   * const userModelBodySpec = spec.of({
   *  username: spec.flow(string.isNotEmpty, any.required),
   *  bestFriend: spec.lazy(() => userModelBodySpec),
   * })
   * 
   * const userModelRequiredSpec = spec.flow(any.requied)
   * 
   * const fullUserModelSpec = spec.compose(
   *  userModelRequiredSpec,
   *  spec.flow(shape.expectKeys(['username', 'bestFriend'])),
   *  userModelBodySpec,
   * )
   * 
   */
  compose: function compose() {
    for (var _len2 = arguments.length, specs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      specs[_key2] = arguments[_key2];
    }

    if (!specs.every(isSpec)) {
      throw new Error('compose args should be the specs');
    }

    return asSpec(function (value, options) {
      var results = [];

      var extOptions = _like["default"].assign({
        context: null,
        untilFail: false
      }, options);

      for (var i = 0, l = specs.length; i < l; i += 1) {
        var spec = specs[i];
        var result = spec(value, extOptions);

        if (_like["default"].isArray(result)) {
          results.push.apply(results, _toConsumableArray(result));
        }

        if (extOptions.untilFail && results.length > 0) {
          return results;
        }
      }

      return nullOrCollection(results);
    });
  },
  // TODO: mb use template method to support diff forms of spec generators

  /**
   * Function helps to create spec fof complex object such as arrays or shapes (aka objects)
   * @function of
   * @memberof module:ego~spec
   * 
   * @arg {Object|Array} specDescriptor - Accepts object where properties' values must be spec functions
   * or array with only one item that is a spec function
   * 
   * @returns {function} - Spec function which could be used as argument
   * 
   * @example
   * 
   * import { spec } from 'egoist-js'
   * 
   * const simpleHeroSpec = spec.of({
   *  name: spec.flow(string.isString, string.isNotEmpty, any.required),
   *  abilities: spec.of([spec.flow(any.required)])
   *  address: spec.of({
   *    city: spec.flow(any.required),
   *    // pls note - spec can be complex
   *    streets: spec.of([spec.of({ zip: spec.flow(any.required) })])
   *  })
   * })
   * 
   */
  of: function of(specDescriptor) {
    if (_like["default"].isArray(specDescriptor)) {
      // spec generator for arrays aka collections
      return asSpec(function (collection, options) {
        var results = [];

        var _fp$assign2 = _like["default"].assign({
          context: null,
          untilFail: false
        }, options),
            context = _fp$assign2.context,
            untilFail = _fp$assign2.untilFail;

        var _specDescriptor = _slicedToArray(specDescriptor, 1),
            spec = _specDescriptor[0];

        var specFn = LazySpec.isLazy(spec) ? spec.lazy() : spec;

        if (!_like["default"].isArray(collection)) {
          return null;
        }

        for (var i = 0, l = collection.length; i < l; i += 1) {
          var value = collection[i];
          var result = specFn(value, {
            context: _context.Context.create(collection, context, i),
            untilFail: untilFail
          });

          if (_like["default"].isArray(result)) {
            results.push.apply(results, _toConsumableArray(result));
          }

          if (untilFail && results.length > 0) {
            return results;
          }
        }

        return nullOrCollection(results);
      });
    } // spec generator for objects aka shapes


    return asSpec(function (value, options) {
      var results = [];

      var _fp$assign3 = _like["default"].assign({
        context: null,
        untilFail: false
      }, options),
          context = _fp$assign3.context,
          untilFail = _fp$assign3.untilFail;

      var kvPairs = _like["default"].entries(specDescriptor);

      for (var i = 0, l = kvPairs.length; i < l; i += 1) {
        var _kvPairs$i = _slicedToArray(kvPairs[i], 2),
            key = _kvPairs$i[0],
            spec = _kvPairs$i[1];

        var specFn = spec.lazy ? spec.lazy() : spec;
        var result = specFn(_like["default"].get(key, value), {
          context: _context.Context.create(value, context, key),
          untilFail: untilFail
        });

        if (_like["default"].isArray(result)) {
          results.push.apply(results, _toConsumableArray(result));
        }

        if (untilFail && results.length > 0) {
          return results;
        }
      }

      return nullOrCollection(results);
    });
  }
};
exports["default"] = _default;

},{"./context":1,"./like.lodash":5}],7:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.freeze = exports.toValidator = exports.toValidatorWithArgs = void 0;

var _like = _interopRequireDefault(require("./like.lodash"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var toValidator = function toValidator(name, isValidFn) {
  return function (value, params) {
    if (value === null || value === undefined) {
      return null;
    }

    return isValidFn(value, params) !== true ? [name] : null;
  };
};

exports.toValidator = toValidator;

var toValidatorWithArgs = function toValidatorWithArgs(name, isValidFn) {
  return function (args) {
    return function (value, params) {
      if (value === null || value === undefined) {
        return null;
      }

      return isValidFn(args, value, params) !== true ? [name, args] : null;
    };
  };
};

exports.toValidatorWithArgs = toValidatorWithArgs;

var freeze = function freeze(shape) {
  var resultShape = {};

  var entries = _like["default"].entries(shape);

  entries.forEach(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        value = _ref2[1];

    if (_like["default"].isObject(value)) {
      resultShape[key] = Object.freeze(freeze(value));
    } else {
      resultShape[key] = value;
    }
  });
  return Object.freeze(resultShape);
};

exports.freeze = freeze;

},{"./like.lodash":5}],8:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _like = _interopRequireDefault(require("./like.lodash"));

var _keys = _interopRequireDefault(require("./defaults/keys"));

var _messages = _interopRequireDefault(require("./defaults/messages"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var isValid = function isValid(specFn, value) {
  return _like["default"].isEmpty(specFn(value, {
    untilFail: true
  }));
};

var isInvalid = function isInvalid(specFn, value) {
  return !_like["default"].isEmpty(specFn(value, {
    untilFail: true
  }));
};

var toTuple = function toTuple(collection) {
  return _like["default"].isArray(collection) ? collection : [];
};

var createValidateFunction = function createValidateFunction(_ref) {
  var untilFail = _ref.untilFail,
      messageFuncs = _ref.messageFuncs;

  var getLabel = _like["default"].getOr('value', 'alias');

  var getParent = _like["default"].get('parent');

  var makeFullPathGetter = function makeFullPathGetter(context) {
    var fullpath = [];

    if (!_like["default"].isObject(context)) {
      return function () {
        return [];
      };
    }

    var cicularRefs = new Set();
    var currentContext = context;

    do {
      fullpath.push(currentContext.key);
      cicularRefs.add(currentContext);
      currentContext = getParent(currentContext);
    } while (!(currentContext == null || cicularRefs.has(currentContext)));

    return function () {
      return _like["default"].reverse(fullpath);
    };
  };

  var formatValidationOutput = function formatValidationOutput(specOutput, customMessages) {
    if (specOutput == null) {
      return null;
    }

    var validationResults = [];
    var defaultMessageFunc = messageFuncs[_keys["default"].ANY.UNKNOWN];
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      var _loop = function _loop() {
        var _step$value = _step.value,
            result = _step$value.result,
            value = _step$value.value,
            context = _step$value.context;

        var _toTuple = toTuple(result),
            _toTuple2 = _slicedToArray(_toTuple, 2),
            name = _toTuple2[0],
            args = _toTuple2[1];

        var messageFn = _like["default"].get(name, customMessages) || messageFuncs[name] || defaultMessageFunc;
        var path = makeFullPathGetter(context);
        validationResults.push({
          message: messageFn({
            label: getLabel(context),
            value: value,

            get path() {
              return path();
            },

            args: args
          }),
          value: value,

          get path() {
            return path();
          },

          args: args
        });
      };

      for (var _iterator = specOutput[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        _loop();
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
          _iterator["return"]();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    return validationResults.length > 0 ? validationResults : null;
  };

  return [function (specFn, value) {
    var specOutput = specFn(value, {
      untilFail: untilFail
    });
    return formatValidationOutput(specOutput);
  }, function (specFn, options, value) {
    var customMessages = _like["default"].get('customMessages', options);

    var specOutput = specFn(value, {
      untilFail: untilFail
    });
    return formatValidationOutput(specOutput, customMessages);
  }];
};

var _createValidateFuncti = createValidateFunction({
  messageFuncs: _messages["default"],
  untilFail: true
}),
    _createValidateFuncti2 = _slicedToArray(_createValidateFuncti, 2),
    validate = _createValidateFuncti2[0],
    validateWithOpts = _createValidateFuncti2[1];

var _createValidateFuncti3 = createValidateFunction({
  messageFuncs: _messages["default"],
  untilFail: false
}),
    _createValidateFuncti4 = _slicedToArray(_createValidateFuncti3, 2),
    validateAll = _createValidateFuncti4[0],
    validateAllWithOpts = _createValidateFuncti4[1];

var _default = {
  /**
   * Curried function tells whether value is valid
   * @function isValid
   * @static
   * 
   * @arg {function} specFn - generated spec function by: {@link module:ego~spec.flow|flow},
   * {@link module:ego~spec.of|of} or
   * {@link module:ego~spec.compose|compose}
   * @arg {any} value - value to check
   * 
   * @returns {boolean} True if value is valid, othervise false
   * 
   * @example
   * 
   * import { isValid, spec, validators } from 'egoist-js'
   * 
   * const { string, any } = validators
   * 
   * const usernameSpec = spec.flow(string.isString, string.isNotEmpty, any.required)
   * console.log(isValid(usernameSpec, 'hello')) // true
   * 
   * const isValidUsernameFn = isValid(usernameSpec)
   * console.log(isValidUsernameFn('nope')) // true
   * console.log(isValidUsernameFn(undefined)) // false
   * console.log(isValidUsernameFn(null)) // false
   * console.log(isValidUsernameFn('')) // false
   * 
   */
  isValid: _like["default"].curry(isValid),

  /**
   * Curried function tells whether value is invalid
   * @function isInvalid
   * @static
   * 
   * @arg {function} specFn - generated spec function by: {@link module:ego~spec.flow|flow},
   * {@link module:ego~spec.of|of} or
   * {@link module:ego~spec.compose|compose}
   * @arg {any} value - value to check
   * 
   * @returns {boolean} True if value is invalid, othervise false
   * 
   * @example
   * 
   * import { isInvalid, spec, validators } from 'egoist-js'
   * 
   * const { string, any } = validators
   * 
   * const usernameSpec = spec.flow(string.isString, string.isNotEmpty, any.required)
   * console.log(isInvalid(usernameSpec, 'hello')) // false
   * 
   * const isInvalidUsernameFn = isInvalid(usernameSpec)
   * console.log(isInvalidUsernameFn('nope')) // false
   * console.log(isInvalidUsernameFn(undefined)) // true
   * console.log(isInvalidUsernameFn(null)) // true
   * console.log(isInvalidUsernameFn('')) // true
   * 
   */
  isInvalid: _like["default"].curry(isInvalid),

  /**
   * Curried function returns validation info if data has errors
   * @function validate
   * @static
   * 
   * @arg {function} specFn - generated spec function by: {@link module:ego~spec.flow|flow},
   * {@link module:ego~spec.of|of} or
   * {@link module:ego~spec.compose|compose}
   * @arg {any} value - value to check
   * 
   * @returns {Object[]|Null} Null if data is valid, otherwise one item array with reason of error
   * 
   * @example
   * 
   * import { validate, spec, validators } from 'egoist-js'
   * 
   * const { shape, number, string, any } = validators
   * 
   * const usernameSpec = spec.flow(string.isString, string.isNotEmpty, any.required)
   * console.log(validate(usernameSpec, 'hello')) // null
   * 
   * const validateUsername = validate(usernameSpec)
   * 
   * console.log(validateUsername(null)) 
   * // [{
   * //  message: 'value is required', 
   * //  value: null, 
   * //  args: undefined, 
   * //  path: [] // path is computed property
   * // }]
   * 
   * 
   * const adultUserModelSpec = spec.compose(
   *  spec.flow(
   *   shape.isShape,
   *   shape.hasKeys('name', 'age'),
   *   any.required,
   *  ),
   *  spec.of({
   *   name: spec.flow(string.isString, string.isNotEmpty, any.required),
   *   age: spec.flow(number.isNumber, number.ge(18), any.required),
   *  })
   * )
   * 
   * const validateAdultUser = validate(adultUserModelSpec)
   * 
   * const validationResult = validateAdultUser({
   *  name: 'Oliver Darkside',
   *  age: 17,
   * })
   * 
   * console.log(validationResult) 
   * // [{ message: 'age should be greater or equal than 18', value: 17, args: 18, path: ['age'] }]
   * 
   */
  validate: _like["default"].curry(validate),

  /**
   * Curried function with opts, returns validation info if data has errors
   * @function validateWithOpts
   * @static
   * 
   * @arg {function} specFn - generated spec function by: {@link module:ego~spec.flow|flow},
   * {@link module:ego~spec.of|of} or
   * {@link module:ego~spec.compose|compose}
   * @arg {Object} opts - options object
   * @arg {Object} opts.customMessages - overrides validation messages for standart library
   * @arg {any} value - value to check
   * 
   * @returns {Object[]|Null} Null if data is valid, otherwise one item array with reason of error
   * 
   * @example
   * 
   * import { validateWithOpts, spec, validators, ERROR_KEYS } from 'egoist-js'
   * 
   * const { shape, number, string, any } = validators
   * 
   * const adultUserModelSpec = spec.of({
   *   name: spec.flow(string.isString, string.isNotEmpty, any.required),
   *   age: spec.flow(number.isNumber, number.ge(18), any.required),
   *   address: spec.of({
   *    city: spec.flow(string.isString, any.required),
   *    street: spec.flow(string.isString, any.required),
   *   })
   * })
   * 
   * const validateAdultUser = validateWithOpts(adultUserModelSpec, {
   *   customMessages: {
   *     [ERROR_KEYS.NUMBER.GE]: ({ label, path, value, args }) => 
   *        `${label} can not contain [${value}], because expects something greater or equal than ${args}`
   *   },
   * })
   * 
   * const reasons = validateAdultUser({
   *  name: 'Alice Morgan',
   *  age: 17,
   *  address: {
   *    city: 'London',
   *    street: 'Fitsrovia st.'
   *  }
   * })
   * 
   * console.log(reasons) 
   * // [{
   * //   message: 'age can not contain [17], because expects something greater or equal than 18',
   * //   args: 18,
   * //   value: 17,
   * //   path: ['age'],
   * // }]
   * 
   */
  validateWithOpts: _like["default"].curry(validateWithOpts),

  /**
   * Curried function returns info about all errors if data has them
   * @function validateAll
   * @static
   * 
   * @arg {function} specFn - generated spec function by: {@link module:ego~spec.flow|flow},
   * {@link module:ego~spec.of|of} or
   * {@link module:ego~spec.compose|compose}
   * @arg {any} value - value to check
   * 
   * @returns {Object[]|Null} Null if data is valid, otherwise array with all reasons of error
   * 
   * @example
   * 
   * import { validateAll, spec, validators } from 'egoist-js'
   * 
   * const { shape, number, string, any } = validators
   * 
   * const simpleSpec = spec.flow(
   *  string.isString,
   *  string.isDigits,
   *  string.isNotEmpty,
   *  any.required
   * )
   * 
   * console.log(validateAll(simpleSpec, 'hello'))
   * // [
   * //   { message: 'value should be a string', value: 'hello', args: undefined, path: [] },
   * //   { message: 'value should contain only digits', value: 'hello', args: undefined, path: [] },
   * // ]
   */
  validateAll: _like["default"].curry(validateAll),

  /**
   * Curried function with opts, returns info about all errors if data has them
   * @function validateAllWithOpts
   * @static
   * 
   * @arg {function} specFn - generated spec function by: {@link module:ego~spec.flow|flow},
   * {@link module:ego~spec.of|of} or
   * {@link module:ego~spec.compose|compose}
   * @arg {Object} opts - options object
   * @arg {Object} opts.customMessages - overrides validation messages for standart library
   * @arg {any} value - value to check
   * 
   * @returns {Object[]|Null} Null if data is valid, otherwise one item array with reason of error
   * 
   * @example
   * 
   * import { validateWithOpts, spec, validators, ERROR_KEYS } from 'egoist-js'
   * 
   * const { shape, number, string, any } = validators
   * 
   * const simpleSpec = spec.flow(
   *  string.isString,
   *  string.isDigits,
   *  string.isNotEmpty,
   *  any.required
   * )
   * 
   * const extValidateAll = validateAll(simpleSpec, {
   *  customMessages: {
   *   [ERROR_KEYS.STRING.TYPE]: ({ label, value, args, path }) => 'yeah, yeah, yeah ${label} should be a string',
   *  },
   * })
   * 
   * console.log(extValidateAll(simpleSpec, 'hello'))
   * // [
   * //   { message: 'yeah, yeah, yeah value should be a string', value: 'hello', args: undefined, path: [] },
   * //   { message: 'value should contain only digits', value: 'hello', args: undefined, path: [] },
   * // ]
   */
  validateAllWithOpts: _like["default"].curry(validateAllWithOpts),

  /**
   * Function helps to create your own validation functions and define your own validation messages
   * @function createValidateFunction
   * @static
   * 
   * @arg {Object} opts - object with `customMessages`, pls look at the example below
   * @arg {boolean} opts.untilFail - tells validation functions when to stop,
   * if true check validators until first fail, else check all of them
   * @arg {Object<string, function>} opts.messageFuncs - object with {@link module:ego~ERROR_KEYS|error keys} and {@link module:ego~ERROR_MESSAGES|error message function}
   *
   * @returns {function[]} tuple with two functions e.g: [validate, validateWithOpts]
   *
   * @example
   * 
   * import {
   *  spec,
   *  createValidateFunction,
   *  toValidator,
   *  toValidatorWithArgs,
   *  ERROR_KEYS,
   *  ERROR_MESSAGES,
   * } from 'egoist-js'
   * 
   * const customeErrorKey = 'my.custom.error.key'
   * 
   * const customMessageFunc = {
   *   ...ERROR_MESSAGES,
   *   [ERROR_KEYS.ANY.REQUIRED]: ({ label, args, value, path }) => `${label} is mandatory`,
   *   [customeErrorKey]: ({ label, args, value, path }) => `${label} bla bla bla`,
   * }
   * 
   * const [cvalidate, cvalidateWithOpts] = createValidateFunction({
   *  untilFail: true,
   *  messageFuncs: customMessageFunc,
   * })
   * 
   *
   * const [cvalidateAll, cvalidateAllWithOpts] = createValidateFunction({
   *  untilFail: true,
   *  messageFuncs: customMessageFunc,
   * })
   * 
   * const customValidator = toValidator(customeErrorKey, (value) => Boolean(value))
   * 
   * console.log(cvalidate(spec.flow(customValidator), 0))
   * // [{ messsge: 'value bla bla bla', value: 0, args: undefined, path: [] }]
   *
   */
  createValidateFunction: createValidateFunction
};
exports["default"] = _default;

},{"./defaults/keys":2,"./defaults/messages":3,"./like.lodash":5}],9:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.allow = exports.required = void 0;

var _like = _interopRequireDefault(require("../like.lodash"));

var _keys = _interopRequireDefault(require("../defaults/keys"));

var _utils = require("../utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/** @module ego */

/** @namespace module:ego~validators/any */
var required = function required(value) {
  return value === null || value === undefined ? [_keys["default"].ANY.REQUIRED] : null;
};

exports.required = required;
var allow = (0, _utils.toValidatorWithArgs)(_keys["default"].ANY.ALLOW, function (args, value) {
  return _like["default"].includes(value, args);
});
exports.allow = allow;

},{"../defaults/keys":2,"../like.lodash":5,"../utils":7}],10:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.length = exports.maxLength = exports.minLength = exports.inRange = exports.every = exports.some = exports.isArray = void 0;

var _like = _interopRequireDefault(require("../like.lodash"));

var _keys = _interopRequireDefault(require("../defaults/keys"));

var _utils = require("../utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var isArray = (0, _utils.toValidator)(_keys["default"].ARRAY.TYPE, _like["default"].isArray);
exports.isArray = isArray;
var minLength = (0, _utils.toValidatorWithArgs)(_keys["default"].ARRAY.MIN_LENGTH, function (minLength, value) {
  return value.length >= minLength;
});
exports.minLength = minLength;
var maxLength = (0, _utils.toValidatorWithArgs)(_keys["default"].ARRAY.MAX_LENGTH, function (maxLength, value) {
  return value.length <= maxLength;
});
exports.maxLength = maxLength;
var length = (0, _utils.toValidatorWithArgs)(_keys["default"].ARRAY.LENGTH, function (length, value) {
  return value.length === length;
});
exports.length = length;
var inRange = (0, _utils.toValidatorWithArgs)(_keys["default"].ARRAY.IN_RANGE, function (_ref, value) {
  var _ref2 = _slicedToArray(_ref, 2),
      min = _ref2[0],
      max = _ref2[1];

  var clength = value.length;
  return min <= clength && clength <= max;
});
exports.inRange = inRange;
var every = (0, _utils.toValidatorWithArgs)(_keys["default"].ARRAY.EVERY, function (predicate, value) {
  return _like["default"].every(predicate, value);
});
exports.every = every;
var some = (0, _utils.toValidatorWithArgs)(_keys["default"].ARRAY.SOME, function (predicate, value) {
  return _like["default"].some(predicate, value);
});
exports.some = some;

},{"../defaults/keys":2,"../like.lodash":5,"../utils":7}],11:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isFalsy = exports.isTruthy = exports.isBoolean = void 0;

var _like = _interopRequireDefault(require("../like.lodash"));

var _keys = _interopRequireDefault(require("../defaults/keys"));

var _utils = require("../utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/** @module ego */

/** @namespace module:ego~validators/boolean */
var isBoolean = (0, _utils.toValidator)(_keys["default"].BOOLEAN.TYPE, _like["default"].isBoolean);
exports.isBoolean = isBoolean;
var isFalsy = (0, _utils.toValidator)(_keys["default"].BOOLEAN.FALSY, function (value) {
  return !value;
});
exports.isFalsy = isFalsy;

var isTruthy = function isTruthy(value) {
  return value ? null : [_keys["default"].BOOLEAN.TRUTHY];
};

exports.isTruthy = isTruthy;

},{"../defaults/keys":2,"../like.lodash":5,"../utils":7}],12:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var any = _interopRequireWildcard(require("./any"));

var _boolean = _interopRequireWildcard(require("./boolean"));

var number = _interopRequireWildcard(require("./number"));

var string = _interopRequireWildcard(require("./string"));

var shape = _interopRequireWildcard(require("./shape"));

var array = _interopRequireWildcard(require("./array"));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

var _default = {
  any: any,
  "boolean": _boolean,
  number: number,
  string: string,
  shape: shape,
  array: array
};
exports["default"] = _default;

},{"./any":9,"./array":10,"./boolean":11,"./number":13,"./shape":14,"./string":15}],13:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isNumber = exports.inRange = exports.le = exports.ge = exports.gt = exports.lt = void 0;

var _like = _interopRequireDefault(require("../like.lodash"));

var _keys = _interopRequireDefault(require("../defaults/keys"));

var _utils = require("../utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var gt = (0, _utils.toValidatorWithArgs)(_keys["default"].NUMBER.GT, function (min, value) {
  return min < value;
});
exports.gt = gt;
var lt = (0, _utils.toValidatorWithArgs)(_keys["default"].NUMBER.LT, function (max, value) {
  return max > value;
});
exports.lt = lt;
var ge = (0, _utils.toValidatorWithArgs)(_keys["default"].NUMBER.GE, function (min, value) {
  return min <= value;
});
exports.ge = ge;
var le = (0, _utils.toValidatorWithArgs)(_keys["default"].NUMBER.LE, function (max, value) {
  return max >= value;
});
exports.le = le;
var inRange = (0, _utils.toValidatorWithArgs)(_keys["default"].NUMBER.RANGE, function (_ref, value) {
  var _ref2 = _slicedToArray(_ref, 2),
      min = _ref2[0],
      max = _ref2[1];

  return value >= min && max > value;
});
exports.inRange = inRange;
var isNumber = (0, _utils.toValidator)(_keys["default"].NUMBER.TYPE, _like["default"].isNumber);
exports.isNumber = isNumber;

},{"../defaults/keys":2,"../like.lodash":5,"../utils":7}],14:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.expectKeys = exports.forbiddenKeys = exports.allowedKeys = exports.isShape = void 0;

var _like = _interopRequireDefault(require("../like.lodash"));

var _keys = _interopRequireDefault(require("../defaults/keys"));

var _utils = require("../utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/** @module ego */

/** @namespace module:ego~validators/shape */
var toSet = function toSet(keys) {
  return new Set(keys);
};

var toKeySet = _like["default"].flow(_like["default"].keys, toSet);

var isShape = (0, _utils.toValidator)(_keys["default"].SHAPE.TYPE, _like["default"].isObject);
exports.isShape = isShape;
var allowedKeys = (0, _utils.toValidatorWithArgs)(_keys["default"].SHAPE.ALLOWED_KEYS, _like["default"].overArgs(function (allowedKeysSet, existingKeys) {
  return existingKeys.every(function (key) {
    return allowedKeysSet.has(key);
  });
}, [toSet, _like["default"].keys]));
exports.allowedKeys = allowedKeys;
var forbiddenKeys = (0, _utils.toValidatorWithArgs)(_keys["default"].SHAPE.FORBIDDEN_KEYS, _like["default"].overArgs(function (forbiddenKeys, existingKeySet) {
  return !forbiddenKeys.some(function (key) {
    return existingKeySet.has(key);
  });
}, [_like["default"].identity, toKeySet]));
exports.forbiddenKeys = forbiddenKeys;
var expectKeys = (0, _utils.toValidatorWithArgs)(_keys["default"].SHAPE.EXPECTED_KEYS, _like["default"].overArgs(function (expectedKeys, existingKeysSet) {
  return expectedKeys.length === existingKeysSet.size && expectedKeys.every(function (key) {
    return existingKeysSet.has(key);
  });
}, [_like["default"].identity, toKeySet]));
exports.expectKeys = expectKeys;

},{"../defaults/keys":2,"../like.lodash":5,"../utils":7}],15:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.length = exports.maxLength = exports.minLength = exports.match = exports.isISODate = exports.isAlphanum = exports.isDigits = exports.isEmail = exports.isNotEmpty = exports.isString = void 0;

var _like = _interopRequireDefault(require("../like.lodash"));

var _keys = _interopRequireDefault(require("../defaults/keys"));

var _utils = require("../utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/** @module ego */

/** @namespace module:ego~validators/string */
var DIGITS_PATTERN = /^\d+$/;
var ALPHANUM_PATTERN = /^[a-zA-Z0-9]+$/;
var EMAIL_PATTERN = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
var ISO_DATE_PATTERN = /(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z))/;
var isString = (0, _utils.toValidator)(_keys["default"].STRING.TYPE, _like["default"].isString);
exports.isString = isString;
var isNotEmpty = (0, _utils.toValidator)(_keys["default"].STRING.EMPTY, function (value) {
  return value !== '';
});
exports.isNotEmpty = isNotEmpty;
var isEmail = (0, _utils.toValidator)(_keys["default"].STRING.EMAIL, function (value) {
  return EMAIL_PATTERN.test(value);
});
exports.isEmail = isEmail;
var isDigits = (0, _utils.toValidator)(_keys["default"].STRING.DIGITS, function (value) {
  return DIGITS_PATTERN.test(value);
});
exports.isDigits = isDigits;
var isAlphanum = (0, _utils.toValidator)(_keys["default"].STRING.ALPHANUM, function (value) {
  return ALPHANUM_PATTERN.test(value);
});
exports.isAlphanum = isAlphanum;
var isISODate = (0, _utils.toValidator)(_keys["default"].STRING.ISO_DATE, function (value) {
  return ISO_DATE_PATTERN.test(value);
});
exports.isISODate = isISODate;
var minLength = (0, _utils.toValidatorWithArgs)(_keys["default"].STRING.MIN_LENGTH, function (minLength, value) {
  return value.length >= minLength;
});
exports.minLength = minLength;
var maxLength = (0, _utils.toValidatorWithArgs)(_keys["default"].STRING.MAX_LENGTH, function (maxLength, value) {
  return value.length <= maxLength;
});
exports.maxLength = maxLength;
var length = (0, _utils.toValidatorWithArgs)(_keys["default"].STRING.LENGTH, function (length, value) {
  return value.length === length;
});
exports.length = length;
var match = (0, _utils.toValidatorWithArgs)(_keys["default"].STRING.MATCH, function (pattern, value) {
  return pattern.test(value);
});
exports.match = match;

},{"../defaults/keys":2,"../like.lodash":5,"../utils":7}]},{},[4])(4)
});
